export default {
  apiUrl: '/api/regions',
  dataPath: 'result.rows',
  paginationPath: 'data',
  trackBy: 'id',
  detailRowComponentName: 'region-editor',
  onEachSide: 1,
  preloadList: [],
  sortOrder: [{
    field: 'id',
    sortField: 'id',
    direction: 'DESC',
  }],
  paginationTemplate: {
    class: '',
    template: '총 {total}개 중의 {from} 부터 {to}',
  },
  fields: [
    {
      name: '__checkbox',
      titleClass: 'text-center',
      dataClass: 'text-center',
    },
    {
      name: '__slot:actions',
      title: '편집 삭제',
      titleClass: 'center aligned',
      dataClass: 'center aligned',
    },
    {
      name: 'id',
      title: '<p style="white-space: nowrap">아이디</p>',
      sortField: 'id',
      titleClass: 'text-center',
      dataClass: 'text-right',
    },
    {
      name: 'country',
      title: '<i style="white-space: nowrap">국가명</i>',
      sortField: 'country',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'country_en',
      title: '<i style="white-space: nowrap">국가 영문 명</i>',
      sortField: 'country_en',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'region1',
      title: '<i style="white-space: nowrap">지역1</i>',
      sortField: 'region1',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'region1_en',
      title: '<i style="white-space: nowrap">지역1 영문</i>',
      sortField: 'region1_en',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'region2',
      title: '<i style="white-space: nowrap">지역2</i>',
      sortField: 'region2',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'region2_en',
      title: '<i style="white-space: nowrap">지역2 영문</i>',
      sortField: 'region2_en',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'region3',
      title: '<i style="white-space: nowrap">지역3</i>',
      sortField: 'region3',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'region3_en',
      title: '<i style="white-space: nowrap">지역3 영문</i>',
      sortField: 'region3_en',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'region4',
      title: '<i style="white-space: nowrap">지역4</i>',
      sortField: 'region4',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'region4_en',
      title: '<i style="white-space: nowrap">지역4 영문</i>',
      sortField: 'region4_en',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'region_dsc_subtitle',
      title: '<i style="white-space: nowrap">간단한 지역 설명</i>',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'img_region',
      title: '<p style="white-space: nowrap">지역 이미지</p>',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'imgField',
    },
    {
      name: 'region_dsc',
      title: '<i style="white-space: nowrap">설명</i>',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'is_checked',
      title: '<p style="white-space: nowrap">발행</p>',
      sortField: 'is_checked',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'toggleField',
    },
    {
      name: '__slot:actions',
      title: '편집 삭제',
      titleClass: 'center aligned',
      dataClass: 'center aligned',
    },
  ],
};



// WEBPACK FOOTER //
// ./src/spa/components/board/region/Config.js